/* Dujasic: eigen fotoviewer voor de productpagina. Foto past helemaal in beeld, swipen (telefoon), pijltjes en toetsen (laptop). */
if (!customElements.get('product-modal')) {
  (function () {
    var STYLE_ID = 'dj-lb-style';
    var CSS = [
      '.dj-lb{position:fixed;inset:0;z-index:10000;background:rgba(0,0,0,.96);opacity:0;transition:opacity .2s ease;font-family:var(--font-body-family,sans-serif)}',
      '.dj-lb.is-open{opacity:1}',
      '.dj-lb__track{display:flex;width:100%;height:100%;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;scrollbar-width:none}',
      '.dj-lb__track::-webkit-scrollbar{display:none}',
      '.dj-lb__slide{flex:0 0 100%;width:100%;height:100%;scroll-snap-align:center;scroll-snap-stop:always;display:flex;align-items:center;justify-content:center;box-sizing:border-box;padding:64px 12px 56px}',
      '.dj-lb__slide img{display:block;max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain;border-radius:12px;user-select:none;-webkit-user-select:none;-webkit-user-drag:none}',
      '.dj-lb__close,.dj-lb__nav{position:absolute;display:flex;align-items:center;justify-content:center;border:0;border-radius:50%;background:rgba(255,255,255,.14);color:#fff;cursor:pointer;padding:0;transition:background .15s ease,opacity .15s ease}',
      '.dj-lb__close:hover,.dj-lb__nav:hover{background:rgba(255,255,255,.28)}',
      '.dj-lb__close{top:max(14px,env(safe-area-inset-top));right:14px;width:44px;height:44px;font-size:30px;line-height:1;z-index:2}',
      '.dj-lb__nav{top:50%;transform:translateY(-50%);width:52px;height:52px;z-index:2;display:none}',
      '.dj-lb__prev{left:20px}',
      '.dj-lb__next{right:20px}',
      '.dj-lb__nav[disabled]{opacity:.25;cursor:default}',
      '.dj-lb__count{position:absolute;left:0;right:0;bottom:max(16px,env(safe-area-inset-bottom));text-align:center;color:#fff;font-size:1.4rem;letter-spacing:.08em;z-index:2;pointer-events:none}',
      '@media screen and (min-width:750px){.dj-lb__slide{padding:64px 96px 56px}.dj-lb__nav{display:flex}}',
      '@media (prefers-reduced-motion:reduce){.dj-lb{transition:none}}'
    ].join('\n');

    var active = null;

    function addStyle() {
      if (document.getElementById(STYLE_ID)) return;
      var s = document.createElement('style');
      s.id = STYLE_ID;
      s.textContent = CSS;
      document.head.appendChild(s);
    }

    function collectImages(modal) {
      var list = [];
      modal.querySelectorAll('.product-media-modal__content img[data-media-id]').forEach(function (img) {
        if (img.classList.contains('product__media-item--variant') && img.parentElement.firstElementChild !== img) return;
        list.push(img);
      });
      return list;
    }

    function chevron(direction) {
      var d = direction === 'left' ? 'M15 18l-6-6 6-6' : 'M9 18l6-6-6-6';
      return "<svg viewBox='0 0 24 24' width='26' height='26' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='" + d + "'/></svg>";
    }

    function closeLightbox() {
      if (!active) return;
      var a = active;
      active = null;
      document.removeEventListener('keydown', a.onKey);
      window.removeEventListener('resize', a.onResize);
      if (a.lockedBody) document.body.classList.remove('overflow-hidden');
      a.root.classList.remove('is-open');
      setTimeout(function () {
        if (a.root.parentNode) a.root.parentNode.removeChild(a.root);
      }, 200);
      if (a.opener && typeof a.opener.focus === 'function') a.opener.focus();
    }

    function openLightbox(modal, opener) {
      addStyle();
      closeLightbox();

      var sources = collectImages(modal);
      if (!sources.length) return;

      var mediaId = opener && opener.getAttribute ? opener.getAttribute('data-media-id') : null;
      var current = 0;
      sources.forEach(function (img, i) {
        if (img.getAttribute('data-media-id') === mediaId) current = i;
      });

      var root = document.createElement('div');
      root.className = 'dj-lb';
      root.setAttribute('role', 'dialog');
      root.setAttribute('aria-modal', 'true');
      root.setAttribute('aria-label', 'Productfoto\'s');

      var track = document.createElement('div');
      track.className = 'dj-lb__track';

      var images = [];
      sources.forEach(function (src, i) {
        var slide = document.createElement('div');
        slide.className = 'dj-lb__slide';
        var im = document.createElement('img');
        im.alt = src.getAttribute('alt') || ('Productfoto ' + (i + 1));
        im.decoding = 'async';
        im.draggable = false;
        var srcset = src.getAttribute('srcset');
        if (srcset) {
          im.setAttribute('srcset', srcset);
          im.setAttribute('sizes', '100vw');
        }
        im.src = src.getAttribute('src');
        im.loading = Math.abs(i - current) <= 1 ? 'eager' : 'lazy';
        slide.appendChild(im);
        slide.addEventListener('click', function (e) {
          if (e.target === slide) closeLightbox();
        });
        track.appendChild(slide);
        images.push(im);
      });

      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'dj-lb__close';
      closeBtn.setAttribute('aria-label', 'Sluiten');
      closeBtn.innerHTML = '&times;';

      var prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'dj-lb__nav dj-lb__prev';
      prevBtn.setAttribute('aria-label', 'Vorige foto');
      prevBtn.innerHTML = chevron('left');

      var nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'dj-lb__nav dj-lb__next';
      nextBtn.setAttribute('aria-label', 'Volgende foto');
      nextBtn.innerHTML = chevron('right');

      var count = document.createElement('div');
      count.className = 'dj-lb__count';
      count.setAttribute('aria-live', 'polite');

      root.appendChild(track);
      root.appendChild(closeBtn);
      if (sources.length > 1) {
        root.appendChild(prevBtn);
        root.appendChild(nextBtn);
        root.appendChild(count);
      }

      function slideWidth() {
        return track.clientWidth || window.innerWidth;
      }

      function update() {
        var i = Math.round(track.scrollLeft / slideWidth());
        i = Math.max(0, Math.min(sources.length - 1, i));
        current = i;
        count.textContent = (i + 1) + ' / ' + sources.length;
        prevBtn.disabled = i === 0;
        nextBtn.disabled = i === sources.length - 1;
        [i - 1, i + 1].forEach(function (n) {
          if (images[n] && images[n].loading === 'lazy') images[n].loading = 'eager';
        });
      }

      function go(delta) {
        var target = Math.max(0, Math.min(sources.length - 1, current + delta));
        track.scrollTo({ left: target * slideWidth(), behavior: 'smooth' });
      }

      var raf = null;
      track.addEventListener(
        'scroll',
        function () {
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = null;
            update();
          });
        },
        { passive: true }
      );

      closeBtn.addEventListener('click', closeLightbox);
      prevBtn.addEventListener('click', function () { go(-1); });
      nextBtn.addEventListener('click', function () { go(1); });

      function onKey(e) {
        if (e.key === 'Escape') {
          e.preventDefault();
          closeLightbox();
        } else if (e.key === 'ArrowLeft') {
          go(-1);
        } else if (e.key === 'ArrowRight') {
          go(1);
        } else if (e.key === 'Tab') {
          var f = [closeBtn, prevBtn, nextBtn].filter(function (b) {
            return b.parentNode && !b.disabled && b.offsetParent !== null;
          });
          if (!f.length) return;
          var idx = f.indexOf(document.activeElement);
          if (e.shiftKey && idx <= 0) {
            e.preventDefault();
            f[f.length - 1].focus();
          } else if (!e.shiftKey && (idx === f.length - 1 || idx === -1)) {
            e.preventDefault();
            f[0].focus();
          }
        }
      }

      function onResize() {
        track.scrollLeft = current * slideWidth();
      }

      var lockedBody = !document.body.classList.contains('overflow-hidden');
      if (lockedBody) document.body.classList.add('overflow-hidden');

      document.body.appendChild(root);
      track.scrollLeft = current * slideWidth();
      update();
      document.addEventListener('keydown', onKey);
      window.addEventListener('resize', onResize);

      active = { root: root, onKey: onKey, onResize: onResize, lockedBody: lockedBody, opener: opener };

      requestAnimationFrame(function () {
        root.classList.add('is-open');
        closeBtn.focus();
      });
    }

    customElements.define(
      'product-modal',
      class ProductModal extends ModalDialog {
        constructor() {
          super();
        }

        show(opener) {
          this.openedBy = opener;
          if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
          openLightbox(this, opener);
        }

        hide() {
          closeLightbox();
        }
      }
    );
  })();
}
